module.exports = __webpack_public_path__ + "img/1.26b1df40.jpg";